// Tailwind Info Cards Carousel JavaScript
document.addEventListener("DOMContentLoaded", function () {
  initFlipCards();

  // Find all carousel containers on the page
  const carouselContainers = document.querySelectorAll(".carousel-container");

  carouselContainers.forEach(function (container) {
    const sectionRoot = container.closest(".ff--container") || container.parentElement;
    const slides = container.querySelectorAll(".carousel-slide");
    const prevBtn = sectionRoot.querySelector(".carousel-prev");
    const nextBtn = sectionRoot.querySelector(".carousel-next");
    const dots = sectionRoot.querySelectorAll(".carousel-dot");

    if (slides.length === 0) return;

    let currentSlide = 0;
    const totalSlides = slides.length;

    function getSlideOffset(index) {
      const slide = slides[index];
      if (!slide) return 0;
      // Center the target slide in the scrollport (accounts for side padding + gaps)
      return (
        slide.offsetLeft -
        (container.clientWidth - slide.offsetWidth) / 2
      );
    }

    function getCurrentSlideFromScroll() {
      const containerCenter = container.scrollLeft + container.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(slideCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    // Initialize carousel
    function initCarousel() {
      updateNavigation();
      updatePagination();
    }

    // Update navigation buttons
    function updateNavigation() {
      if (prevBtn) prevBtn.disabled = currentSlide <= 0;
      if (nextBtn) nextBtn.disabled = currentSlide >= totalSlides - 1;
    }

    // Update pagination dots
    function updatePagination() {
      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === currentSlide);
      });
    }

    // Go to specific slide
    function goToSlide(index) {
      if (index < 0 || index >= totalSlides) return;

      currentSlide = index;
      container.scrollTo({
        left: getSlideOffset(index),
        behavior: "smooth",
      });

      updateNavigation();
      updatePagination();
    }

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener("click", () => goToSlide(currentSlide - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => goToSlide(currentSlide + 1));
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    // Handle scroll events to update current slide
    container.addEventListener("scroll", () => {
      const newCurrentSlide = getCurrentSlideFromScroll();

      if (newCurrentSlide !== currentSlide) {
        currentSlide = newCurrentSlide;
        updateNavigation();
        updatePagination();
      }
    });

    // Initialize on load
    initCarousel();
  });

  // Handle window resize for all carousels
  window.addEventListener("resize", () => {
    setTimeout(() => {
      carouselContainers.forEach(function (container) {
        const sectionRoot = container.closest(".ff--container") || container.parentElement;
        const slides = container.querySelectorAll(".carousel-slide");
        const prevBtn = sectionRoot.querySelector(".carousel-prev");
        const nextBtn = sectionRoot.querySelector(".carousel-next");
        const dots = sectionRoot.querySelectorAll(".carousel-dot");

        if (slides.length > 0) {
          const containerCenter = container.scrollLeft + container.clientWidth / 2;
          let currentSlide = 0;
          let closestDistance = Infinity;

          slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const distance = Math.abs(slideCenter - containerCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              currentSlide = index;
            }
          });

          if (prevBtn) prevBtn.disabled = currentSlide <= 0;
          if (nextBtn) nextBtn.disabled = currentSlide >= slides.length - 1;

          dots.forEach((dot, index) => {
            dot.classList.toggle("active", index === currentSlide);
          });
        }
      });
    }, 100);
  });
});

function initFlipCards() {
  document.querySelectorAll(".ff--flip-card").forEach(function (card) {
    const front = card.querySelector(".ff--flip-card-front");
    const back = card.querySelector(".ff--flip-card-back");

    if (!front || !back) return;

    function setFlipped(flipped) {
      card.setAttribute("aria-expanded", flipped ? "true" : "false");
      card.classList.toggle("is-flipped", flipped);
      front.setAttribute("aria-hidden", flipped ? "true" : "false");
      back.setAttribute("aria-hidden", flipped ? "false" : "true");
    }

    card.addEventListener("focus", function () {
      setFlipped(true);
    });

    card.addEventListener("blur", function () {
      setFlipped(false);
    });

    card.addEventListener("mouseenter", function () {
      setFlipped(true);
    });

    card.addEventListener("mouseleave", function () {
      if (!card.matches(":focus")) {
        setFlipped(false);
      }
    });
  });
}
